/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { addOrUpdateTooltips } from '../../../../assets/ts/data/tooltip'
import { scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import InputText from '../../../../utils/controls/input-text'

interface Props {
  cancel: () => void,
  editItems: any | null,
  fetchMetdata: () => void,
  filtersvalue: any,
  showAddPopup: boolean
}
const AddEditView = ({
  cancel,
  editItems,
  fetchMetdata,
  filtersvalue,
  showAddPopup,
}: Props) => {

  if (showAddPopup) {
    scrollToTop()
  }
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const [inputValues, setInputValues] = useState({
    Description: editItems?.description ? editItems.description : '',
  })
  const [showAlert, setShowAlert] = useState(false)
  const onClickAlert = async () => {
    setShowAlert(false)
  }

  const [toolTipValidations, setToolTipValidations] = useState({
    Description: false,
  })
  const handleDescriptionChange = (e: any) => {
    setInputValues((prev) => ({
      ...prev,
      Description: e.target.value
    }))
  }

  const updateToolTips = async () => {
    const userdetails = mpfRListsHttp().me()
    setShowPageOverlay(true)
    const userId = (await userdetails).userId
    const currentDate = new Date()

    const addUpdateObj = {

      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      TooltipDescription: inputValues.Description,
      TooltipID: editItems ? editItems.labelid : '',
      TooltipName: editItems ? editItems.name : '',
      eKey: editItems ? editItems.ItemKey : '',
      eTag: editItems ? editItems.eTag : '',
    }

    let isNoChangesDetected = false
    if (inputValues.Description === editItems?.description) {
      isNoChangesDetected = true
      setShowAlert(true)
    }

  if (!isNoChangesDetected) {
    try {
      await addOrUpdateTooltips(addUpdateObj)
      cancel()
    } catch (error) {
      console.error(error)
      cancel()
      setShowPageOverlay(false)
    }
  } else {
    setShowPageOverlay(false)
  }
  }

  const handleSubmit = async () => {
    let isValid = true
    const validations = {
      Description: false,
    }

    if (inputValues.Description === '') {
      isValid = false
      validations.Description = true
    }
    setToolTipValidations(validations)

    if (isValid) {
      await updateToolTips()
      await fetchMetdata()
    }
  }

  return (
    <div
      className={
        showAddPopup
          ? 'mx-2 border-radius whitebg border-primary mt-2'
          : 'whitebg settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      {showAddPopup && (
        <div className='p-3 border-bottom1'>
          <h4
            aria-label=' Add Form Tooltip'
            className='m-0 p-0 d-inline-block font-15 poppins-medium color-primary textcolor4 text-uppercase'
            tabIndex={0}
          >
            Add Form Tooltip
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className='col-sm-12 col-md-6 mb-2'>
            <InputText
              disabled
              formClassName='d-flex flex-column'
              info='Tooltip Name'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' TooltipName ',
                name: 'Tooltip Name',
                placeholder: 'Status',
                value: editItems?.name ? editItems.name : '',
              }}
              isInfo
              isMandatory
              label='Tooltip Name'
            />
          </div>
          <div className='col-sm-12 col-md-6 mb-2'>
            <InputText
              disabled
              formClassName='d-flex flex-column'
              info='Tooltip ID'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' TooltipID  ',
                name: ' Tooltip ID ',
                placeholder: 'Profile Status',
                value: editItems?.labelid ? editItems.labelid : '',
              }}
              isInfo
              isMandatory
              label=' Tooltip ID  '
            />
          </div>
          <div className='col-sm-12 col-md-6 mb-2'>
            <InputText
              changeHandler={handleDescriptionChange}
              error={toolTipValidations?.Description}
              formClassName='d-flex flex-column'
              info='Description'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Description ',
                name: ' Description',
                placeholder: 'Choose your status',
                value: inputValues.Description,
              }}
              isInfo
              isMandatory
              label='Description'
              value={inputValues.Description}
            />
          </div>
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
